/**
 * TableRow Node Extension
 * 表格行节点
 */

import type { NodeSpec } from '../../core/types';
import { NodeExtension } from '../../core/Extension';

export class TableRow extends NodeExtension {
  get name(): string {
    return 'tableRow';
  }

  get schema(): NodeSpec {
    return {
      content: 'tableCell+',
      tableRole: 'row',
      parseDOM: [{ tag: 'tr' }],
      toDOM() {
        return ['tr', { class: 'editor-table-row' }, 0];
      },
    };
  }
}

export default TableRow;
